import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';
import { MysqlService } from './../../../../services/mysql.service';
import { SubjectNote } from './../../../../api/subjectNote';
import {DemoService} from '../../../../demo.service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';

@Component({
  selector: 'app-subject-close',
  templateUrl: './subject-close.component.html',
  styleUrls: ['./subject-close.component.css']
})
export class SubjectCloseComponent implements OnInit {


  @Input() subject_id: number;
  @Input() job_id: number;
  @Input() file_number: number;
  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  modalRef: BsModalRef;
  subject_billing: any;
  subjects: any;
  model: any;
  subjects_not_closed_count: any;

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    public gfunc: GlobalFunctionsService
  ) {

    // login vars
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log('sessionUserId: ', this.currentUserVAR.user_id );
    console.log('sessionUsername: ', this.currentUserVAR.username );
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUsername = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
    this.brand_id = this.sessionBrandId;
    // this.toastr.setRootViewContainerRef(vcr);

   }

  ngOnInit() {
    this.getSubjectBilling(this.subject_id);
    
    this.getJobSubject(this.subject_id);

    this.getSubjectsNotClosed(this.job_id, this.file_number);
  }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}



getSubjectBilling(subject_id) {
  this._demoService.getSubjectBilling(subject_id).subscribe(
    data => { this.subject_billing = data;
     // console.log("Done loadng USER");
    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }


  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subjects = data;
        const res = data[0];
       // this.getSubjectNotes(res.subject_id);

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getSubjectsNotClosed(job_id, file_number) {
    this._demoService.getSubjectsNotClosed(job_id, file_number).subscribe(
       data => { this.subjects_not_closed_count = data;
       // const res = data[0];
       // this.getSubjectNotes(res.subject_id);

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


closeSubject(model){
  model.job_status = 'CLOSED';
  model.job_id = this.job_id;
  this._demoService.closeSubject(model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    // this.toastr.success('Subject Closed');
    this.gfunc.insertLog_UpdateSubjectClose(model); // updated
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
  },
    error => {
     // console.error('Error saving Event!');
      // this.toastr.error('Error Closing Subject');
     return console.log(error);
    }
   // err => console.error(err),
   // () => console.log('done updates')
);
}




}
